module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap1",
    attrs: {
      "id": "ded"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/Text/pppthreeletter005#toc"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("To Louis Henry Silverstein"), _c('br', {
    staticClass: "chap"
  }), _vm._v("1938-2001")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("Chairman, Editorial Review Committee"), _c('br', {
    staticClass: "chap"
  }), _vm._v("who delighted in being known as"), _c('br', {
    staticClass: "chap"
  }), _vm._v("The Poisoned Pen Press CERC")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6beb2b10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/pppthreeletter004.vue
// module id = 66
// module chunks = 0